__webpack_require__.p = "https://learnwarecenter.se/lwc/";